import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { connect } from "react-redux";
import { store } from "../../../store/configureStore";
import { useHistory, useLocation } from "react-router-dom/cjs/react-router-dom.min";
import { CoachMark } from "react-coach-mark";
import {
	createVisitHistory,
	handleCreateCheckItem,
	handleRemoveImportantItem,
	visitHistory
} from "../../../actions/periscope";
import { lS, scroll, trackEvent } from "../../../atlas-utils";
import { useOnClickOutside } from "../../../hooks/useOnClickOutside";
import { ActionTypes } from "../../../actions/_types";
import { getBrandDetail, getPlatformDetailViaName, getRenderToolTipItemAvailability } from "../../../helpers/periscope";
import ReactTable from "../../../components/Periscope/NewTable/ReactTable";
import EntityCard from "../../../components/Periscope/NewTable/EntityCard";
import EntityCell from "../../../components/Periscope/NewTable/EntityCell";
import EntityHead from "../../../components/Periscope/NewTable/EntityHead";
import { CATALOGUE_PLATFORMS_LOGO } from "../../../client-config";

const ItemTable = ({
	tableData,
	platformCount,
	defaultPlatforms,
	periscopeItemAvailabilityData,
	periscopeItemAvailabilityState,
	handlePagination,
	handlePageSize,
	login,
	isMultibrandEnabled,
	refreshBtn,
	periscopeCountryWiseSupportedPlatforms,
	configItems
}) => {
	const data = periscopeItemAvailabilityData?.item?.data?.objects?.data;
	const loading = periscopeItemAvailabilityData?.item?.loading;
	const error = periscopeItemAvailabilityData?.item?.error;
	const country = (login?.loggedInbizDetail?.country || lS.get("auth")?.biz?.country).toLowerCase();
	const bizPlatforms = configItems?.bizPlatforms?.items.filter((platform) => {
		if (platform.platformName == "All Platforms") {
			return true;
		}
		return (periscopeCountryWiseSupportedPlatforms?.[country] ||
			lS.get("periscopeCountryWisePlatforms")?.[country])?.[platform.platformName.toLowerCase()]?.enabled;
	});
	const dataCount = periscopeItemAvailabilityState.count || 0;
	const limit = periscopeItemAvailabilityState.limit;
	const offset = periscopeItemAvailabilityState.offset;

	const history = useHistory();

	const redirectToDetailedView = (data, rest) => {
		const propsValue = rest?.propsValue;
		const cell = rest?.totalRow;
		if (!cell) {
			return;
		}
		let total = propsValue?.total;
		let foodItem = cell?.row?.allCells[0]?.value?.item;
		if (total !== 0) {
			trackEvent("periscope_detail_view_clicked", { module: "item_availability" });
			store.dispatch({
				type: ActionTypes.SPECIFIC_ITEM_AVAILABILITY_STATE_ITEM_FILTERS,
				payload: {
					currentFilters: { platform_names: [cell.column.id] },
					appliedFilters: { platform_names: [cell.column.id] }
				}
			});
			store.dispatch({
				type: ActionTypes.SPECIFIC_ITEM_AVAILABILITY_ITEM_INITIAL_STATE
			});
			const platformId = getPlatformDetailViaName(cell.column.id, bizPlatforms).id;
			let queryParam = `?platform_id=${platformId}&platform=${cell.column.id}${
				isMultibrandEnabled
					? `&brand_id=${cell.row.allCells[0].value?.brand_id}&brand=${cell.row.allCells[0].value?.brand}`
					: ""
			}`;
			history.push(`/periscope/item-availability/item/${foodItem}${queryParam}`);
		}
	};

	const dispatchSortFunction = (sort) => {
		if (sort == null) {
			store.dispatch({
				type: ActionTypes.ITEM_AVAILABILITY_INITIAL_SORT
			});
		} else {
			store.dispatch({
				type: ActionTypes.ITEM_AVAILABILITY_STATE_FILTERS,
				payload: sort
			});
		}
	};

	const sortThePlatform = (column) => {
		const currentSort = periscopeItemAvailabilityState?.sort || {};
		const isCurrentColumn = currentSort.field === column;
		let order, sort;
		store.dispatch({
			type: ActionTypes.ITEM_AVAILABILITY_STATE_FILTERS,
			payload: { offset: 0 }
		});
		if (isCurrentColumn) {
			order = currentSort.order === "asc" ? "desc" : currentSort.order === "desc" ? null : "asc";
			sort = order ? { sort: { field: column, order } } : null;
		} else {
			order = "asc";
			sort = { sort: { field: column, order } };
		}
		dispatchSortFunction(sort);
	};

	useEffect(() => {
		let variables = {
			bizId: String(login.loggedInbizDetail.id)
		};
		visitHistory(variables);
	}, []);

	const hasVisitedItemsAvailability = periscopeItemAvailabilityState?.visitHistory?.hasVisitedItemsAvailability;
	const hasVisitedItemsIssue = periscopeItemAvailabilityState?.visitHistory?.hasVisitedItemsIssue;
	const [showCoachMark, setShowCoachMark] = useState(false);
	const apiDataTable = useRef(null);
	let tableDataInitialDiv = useRef(null);
	const [activatedNumber, setActivatedNumber] = useState(0);
	const coachRef = useRef(null);
	const coachList = [
		{
			activate: showCoachMark && activatedNumber === 0,
			component: (
				<div className="coach-mark-hover-div" style={{ padding: "8px 12px 12px 12px " }} ref={coachRef}>
					<span className="coach-mark-para1">Selecting Important Items</span> <br></br>
					<span className="coach-mark-para2">Monitor your important menu items across various reports</span>
				</div>
			),
			reference: tableDataInitialDiv,
			tooltip: { position: "right", margin: "" }
		}
	];

	useEffect(() => {
		const timeout = setTimeout(() => {
			if (data?.length > 0 && !hasVisitedItemsAvailability && !loading && !error) {
				if (apiDataTable.current) {
					scroll({ top: 0, left: 0 });
					const firstTd = document.querySelector(
						".item-availability-item tbody tr td:first-child .entity-card .label-important"
					);
					if (firstTd) {
						tableDataInitialDiv.current = firstTd;
						setShowCoachMark(true);
						document.body.style.overflow = "hidden";
					}
				}
			}
		}, 1000);
		return () => clearTimeout(timeout);
	}, [data, loading]);

	useOnClickOutside(coachRef, (event) => handleClickOutside(event));

	const handleClickOutside = (event) => {
		setShowCoachMark(false);
		document.body.style.overflow = "auto";
		let variables = {
			bizId: String(login.loggedInbizDetail.id),
			hasVisitedItemsAvailability: true,
			hasVisitedItemsIssue: hasVisitedItemsIssue
		};
		createVisitHistory(variables);
	};

	useEffect(() => {
		let variables = {
			bizId: String(login.loggedInbizDetail.id)
		};
		visitHistory(variables);
	}, []);
	const brands = configItems?.brands?.items || [];

	const location = useLocation();
	const queryParams = new URLSearchParams(location.search);

	const handleClickImportant = async (initialValue) => {
		const { propsValue } = initialValue;
		const val = { ...propsValue };
		const view = queryParams.get("view") ? queryParams.get("view") : "item";
		if (val?.is_important) {
			let variables = {
				itemId: String(val?.important_item_id)
			};
			const respItemId = await handleRemoveImportantItem(variables);
			if (respItemId) {
				store.dispatch({
					type: "ITEM_AVAILABILITY_ORIGINAL_DATA_CHANGE",
					payload: { id: respItemId, view }
				});
			}
		} else {
			let variables = {
				bizId: String(login.loggedInbizDetail.id),
				brandId: isMultibrandEnabled ? val.brand_id : null,
				name: val.item
			};
			let receivedId = await handleCreateCheckItem(variables);

			if (receivedId && receivedId?.id) {
				store.dispatch({
					type: "ITEM_AVAILABILITY_ORIGINAL_DATA_CHANGE_FALSE_VALUE",
					payload: { id: receivedId, view }
				});
			}
		}
	};

	const columnsData = useMemo(() => {
		return ["brandItem", ...tableData].map((col) => {
			return {
				id: col,
				render: () => {
					return (
						<EntityHead
							title={col}
							{...(col !== "Brand-Item" &&
								col !== "brandItem" && {
									imgSrc:
										getPlatformDetailViaName(col, bizPlatforms)?.image ||
										CATALOGUE_PLATFORMS_LOGO[col],
									sort: true,
									handleSortClick: sortThePlatform,
									sortOrder: periscopeItemAvailabilityState.sort?.order,
									sortedField: periscopeItemAvailabilityState.sort?.field
								})}
						/>
					);
				}
			};
		});
	}, [tableData, (bizPlatforms || []).length, periscopeItemAvailabilityState.sort]);

	const renderCellToolTip = useCallback(
		getRenderToolTipItemAvailability({
			unitText: "locations",
			showHint: true
		}),
		[]
	);

	const duplicateValues = useMemo(() => {
		let valuesPattern = ["null", "null", "null", "undefined", "undefined", "undefined"];
		let indexInPattern = 0;
		return Array.from({ length: 9 }).map((_) => {
			let obj = {};
			["brandItem", ...tableData].forEach((key) => {
				obj[key] = valuesPattern[indexInPattern];
			});
			indexInPattern = (indexInPattern + 1) % valuesPattern.length;
			return obj;
		});
	}, [tableData, defaultPlatforms]);

	const newColumns = useMemo(() => {
		return Object.keys(loading || error ? duplicateValues?.[0] || {} : data?.[0] || {}).map((obj) => ({
			Header: (
				<EntityHead
					title={obj}
					{...(obj !== "brandItem" && {
						sort: true,
						imgSrc: getPlatformDetailViaName(obj, bizPlatforms)?.image || CATALOGUE_PLATFORMS_LOGO[obj],
						handleSortClick: sortThePlatform,
						sortOrder: periscopeItemAvailabilityState.sort?.order,
						sortedField: periscopeItemAvailabilityState.sort?.field
					})}
				/>
			),
			accessor: obj,
			enableRowSpan: false,

			Cell: (props) => {
				if (props.column.id == "brandItem") {
					const currentBrand = props?.value?.brand_id && getBrandDetail(props?.value?.brand_id, brands);
					return (
						<EntityCard
							{...(isMultibrandEnabled && {
								displayIcon: true,
								imgSrc: currentBrand?.image,
								brandText: currentBrand?.name,
								iconColor: currentBrand?.color
							})}
							loading={loading}
							error={error}
							rating={props?.value?.rating}
							ratingText
							star
							title={props.value?.item}
							labelImportant
							important={props.value?.is_important}
							propsValue={props?.value}
							handleClickImportant={handleClickImportant}
						/>
					);
				} else {
					const totalLocations = props.value?.total;
					const onlineLocations = props.value?.available;
					const stringValue =
						totalLocations == onlineLocations && onlineLocations !== 0
							? "true-state"
							: onlineLocations == 0 && totalLocations > 0
								? "false-state"
								: totalLocations == 0
									? "custom"
									: "false-state";

					const customContent =
						onlineLocations > 0 && totalLocations > 0 && onlineLocations !== totalLocations;
					const children = (
						<div className="custom-percentage">
							{((onlineLocations / totalLocations) * 100).toFixed(2).replace(/\.00$/, "")}%
						</div>
					);

					return (
						<EntityCell
							loading={loading}
							error={error}
							styles={{ width: platformCount }}
							classes={`${
								stringValue == "true-state"
									? "true-state cursor-pointer"
									: stringValue == "false-state" || stringValue == "custom-cell"
										? "false-state cursor-pointer"
										: "empty-state"
							}
										`}
							value={stringValue == "true-state" ? true : stringValue == "false-state" ? false : null}
							customToolTip={true}
							renderToolTip={renderCellToolTip}
							handleCellClick={redirectToDetailedView}
							propsValue={props?.value}
							totalRow={props}
							children={children}
							customContent={customContent}
						/>
					);
				}
			}
		}));
	}, [data, loading, defaultPlatforms]);

	const renderTableHead = useCallback(() => {
		return (
			<>
				<tr>
					<td rowSpan={2} className="item-tablehead-text brand-item-td">
						{isMultibrandEnabled ? "Brand - Item" : "Item"}
					</td>
					<td className="item-tablehead-text location-item-td" colSpan={platformCount.count}>
						Locations with item
					</td>
				</tr>
				<tr>
					{tableData.map((col, index) => {
						return (
							<td
								key={index}
								className="item-tablehead-text platform-td"
								style={{
									width: platformCount?.percent
								}}
							>
								<EntityHead
									title={col}
									{...(col !== "Brand-Item" &&
										col !== "brandItem" && {
											imgSrc:
												getPlatformDetailViaName(col, bizPlatforms)?.image ||
												CATALOGUE_PLATFORMS_LOGO[col],
											sort: true,
											handleSortClick: sortThePlatform,
											sortOrder: periscopeItemAvailabilityState.sort?.order,
											sortedField: periscopeItemAvailabilityState.sort?.field
										})}
								/>
							</td>
						);
					})}
				</tr>
			</>
		);
	}, [bizPlatforms.length, periscopeItemAvailabilityState.sort, platformCount?.percent]);

	return (
		<>
			<div>
				{defaultPlatforms.length > 0 && (
					<ReactTable
						classes={`item-availability-item  ${!isMultibrandEnabled ? "no-brand" : ""}`}
						loading={loading}
						customTableHead={true}
						renderTableHead={renderTableHead}
						error={error}
						data={loading || error ? duplicateValues : data}
						columns={newColumns}
						colsArray={columnsData}
						thStyles={{
							cols: ["Brand-Item", "brandItem"],
							styles: {
								width: platformCount,
								textAlign: "end"
							}
						}}
						limit={limit}
						offset={offset}
						goToPage={handlePagination}
						setPageSize={handlePageSize}
						count={dataCount}
						fetchData={refreshBtn}
					/>
				)}
				<div className="coach-mark">
					<CoachMark {...coachList[activatedNumber]} />
				</div>
			</div>
		</>
	);
};

const mapStateToProps = (state) => ({
	login: state.login,
	periscopeItemAvailabilityData: state.periscopeItemAvailabilityData,
	isMultibrandEnabled: state.login.loggedInbizDetail.isMultibrandEnabled,
	periscopeItemAvailabilityState: state.periscopeItemAvailabilityState,
	periscopeSpecificItemAvailabilityItemState: state.periscopeSpecificItemAvailabilityItemState,
	periscopeCountryWiseSupportedPlatforms: state.periscopeCountryWiseSupportedPlatforms,
	configItems: state.configItems
});

export default connect(mapStateToProps)(ItemTable);
